import { CenteredLoadingSpinner } from './CenteredLoadingSpinner';
import { Overlay } from './PageLoading.style';

export const PageLoading = () => {
  return (
    <Overlay data-testid="page-loading">
      <CenteredLoadingSpinner />
    </Overlay>
  );
};
